import { apiRequest } from "./baseApi";
import { parseJsonOrThrow } from "./responseUtils";

/**
 * Xandar Kardian vital signs for the sensor bound to a client.
 *
 * Completed-day only: the vendor rejects the current date, so the backend
 * defaults to UTC yesterday when `date` is omitted. Realtime presence and
 * threshold alerts arrive through the alert pipeline, not this read.
 *
 * @param {number|string} clientId
 * @param {string} [date] - YYYY-MM-DD, a completed day
 */
export const getXandarClientVitals = async (clientId, date) => {
  const query = date ? `?date=${encodeURIComponent(date)}` : "";
  const id = encodeURIComponent(clientId);
  const res = await apiRequest(`/iot/xandar/vitals/${id}${query}`, {
    version: "v1",
    method: "GET",
  });
  return parseJsonOrThrow(res, "Xandar Kardian vital signs");
};

/**
 * Newest ingested Xandar sample for this client (iot_events), when fresh.
 * Returns `{ live: null }` when nothing recent is on file — the completed-day
 * card remains the fallback (#542).
 *
 * @param {number|string} clientId
 */
export const getXandarClientLiveVitals = async (clientId) => {
  const id = encodeURIComponent(clientId);
  const res = await apiRequest(`/iot/xandar/vitals/${id}/live`, {
    version: "v1",
    method: "GET",
  });
  return parseJsonOrThrow(res, "Xandar Kardian live vitals");
};
